"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOVA_ELIGIBILITY_COMPASS_FIELDS = exports.INCOME_VERIFICATION_FIELDS = exports.ID_VERIFICATION_FIELDS = exports.VERIFICATION_FAILURE_ACTION_OPTIONS = void 0;
var entities_1 = require("@common/entities");
exports.VERIFICATION_FAILURE_ACTION_OPTIONS = [
    {
        label: 'Do Nothing',
        value: entities_1.VerificationFailureAction.DoNothing,
    },
    {
        label: "Application Can't Be Completed",
        value: entities_1.VerificationFailureAction.ApplicationCantBeCompleted,
    },
    {
        label: 'Lockdown the Application',
        value: entities_1.VerificationFailureAction.LockdownTheApplication,
    },
];
exports.ID_VERIFICATION_FIELDS = [
    {
        label: 'ID Verification',
        type: entities_1.FieldType.YesNo,
        sequence: 1,
        name: 'status',
        customType: entities_1.FieldType.YesNo,
        required: true,
        enabled: true,
    },
];
exports.INCOME_VERIFICATION_FIELDS = [
    {
        label: 'Income Verification',
        type: entities_1.FieldType.YesNo,
        sequence: 1,
        name: 'status',
        customType: entities_1.FieldType.YesNo,
        required: true,
        enabled: true,
    },
];
exports.NOVA_ELIGIBILITY_COMPASS_FIELDS = [
    {
        label: 'NOVA Eligibility Compass',
        type: entities_1.FieldType.YesNo,
        sequence: 1,
        name: 'status',
        customType: entities_1.FieldType.YesNo,
        required: true,
        enabled: true,
    },
];
